/**
 * @generated SignedSource<<66cb2d6e17620a7f556e71e0db1eecea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AfterDateTimeDoShowAnswerTreeConfigForm_TreeNodeFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "AfterDateTimeDoShowAnswerTreeConfigForm_TreeNodeFragment";
};
export type AfterDateTimeDoShowAnswerTreeConfigForm_TreeNodeFragment$key = {
  readonly " $data"?: AfterDateTimeDoShowAnswerTreeConfigForm_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AfterDateTimeDoShowAnswerTreeConfigForm_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AfterDateTimeDoShowAnswerTreeConfigForm_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "9a7018967866aa7cb4d771f586f34037";

export default node;
